import React, { useState } from "react"

import { Form, Label, Row, Col } from "reactstrap"

import toast from "react-hot-toast"
import { useFormik } from "formik"
import * as Yup from "yup"
import Spinners from "components/Common/Spinner"
import authorityLetter from "../../../assets/sample/Authority-Letter.pdf"
import UploadedFileBox from "pages/KYC/uploadedFileBox"
import AuthorityLetterUpload from "pages/KYC/authorityLetterUpload"
import { useUploadAuthorityLetterProfileMutation } from "store/api/profile/profile.api"

const defaultValues = {
  authority_letter: "",
}

const KycAuthorityLetter = ({ kycData }) => {
  const [uploadAuthorityLetter, { isLoading }] =
    useUploadAuthorityLetterProfileMutation()

  const validation = useFormik({
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    validateOnMount: false,
    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  const onFormSubmit = async (values) => {
    try {
      const { success } = await uploadAuthorityLetter(values).unwrap()
      if (success) {
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Upload Authority Letter</h5>
        <p>Please upload document</p>
        <Form onSubmit={validation.handleSubmit}>
          <Row className="mb-2">
            <Col xl={12}>
              <Label className="col-form-label">
                Authority Letter <span className="error">*</span>
              </Label>
              <div className="upload-file-input">
                <a href={authorityLetter} target="_blank" rel="noreferrer">
                  <div className="sample-form">Download Sample Letter</div>
                </a>
                <AuthorityLetterUpload
                  fieldKey={"authority_letter"}
                  validation={validation}
                  extensionAllowedInput={".pdf"}
                  extensionAllowed={["application/pdf"]}
                />
              </div>
            </Col>

            <Col sm={12}>
              <div className="d-flex align-items-center mt-4">
                <button type="submit" className="btn btn-primary w-100">
                  {isLoading ? <Spinners /> : "Save & Next"}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  )
}

export default KycAuthorityLetter
